export const selectCartItems = (state) => state.lotto.cartItems;

export const selectActivity = (state) => state.lotto.activity || 0;

export const selectActiveCartItems = (state) =>
  state.lotto.cartItems.filter((item) => !item.isExpired);

export const selectCartTotalStake = (state) =>
  state.lotto.cartItems
    .filter((item) => !item.isExpired)
    .reduce(
      (total, item) =>
        total +
        item.stake *
          (item.single_bets_count ?? 1) *
          (item.repeat_for_draws ?? 1),
      0
    );

export const selectCartTotalBetsCount = (state) =>
  state.lotto.cartItems
    .filter((item) => !item.isExpired)
    .reduce(
      (total, item) =>
        total + (item.single_bets_count ?? 1) * (item.repeat_for_draws ?? 1),
      0
    );

export const selectCartTotalPotentialPayout = (state) =>
  state.lotto.cartItems
    .filter((item) => !item.isExpired)
    .reduce((total, item) => total + item.potential_payout, 0);
